'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('./constants'),
    breakpoints = _require.breakpoints;

var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !isNaN(n);
};
var px = function px(n) {
  return num(n) ? n + 'px' : n;
};
var em = function em(n) {
  return num(n) ? n + 'em' : n;
};
var neg = function neg(n) {
  return n < 0;
};
var arr = function arr(n) {
  return Array.isArray(n) ? n : [n];
};

var get = function get(obj, path, fallback) {
  return path.split('.').reduce(function (a, b) {
    return a && a[b] ? a[b] : null;
  }, obj) || fallback;
};

var mq = function mq(n) {
  return '@media screen and (min-width: ' + em(n) + ')';
};

var breaks = function breaks(props) {
  return [null].concat((0, _toConsumableArray3.default)(get(props, 'theme.breakpoints', breakpoints).map(mq)));
};

var dec = function dec(props) {
  return function (val) {
    return arr(props).reduce(function (acc, prop) {
      return acc[prop] = val, acc;
    }, {});
  };
};

var media = function media(bp) {
  return function (d, i) {
    return is(d) ? bp[i] ? (0, _defineProperty3.default)({}, bp[i], d) : d : null;
  };
};

var merge = function merge(a, b) {
  return (0, _assign2.default)({}, a, b, (0, _keys2.default)(b).reduce(function (obj, key) {
    return (0, _assign2.default)(obj, (0, _defineProperty3.default)({}, key, a[key] !== null && (0, _typeof3.default)(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
  }, {}));
};

// keeping for backwards-compatibility only
var idx = function idx(keys, obj) {
  return get(obj, keys.join('.')) || null;
};

module.exports = {
  get: get,
  is: is,
  px: px,
  em: em,
  neg: neg,
  num: num,
  arr: arr,
  idx: idx,
  breaks: breaks,
  media: media,
  dec: dec,
  merge: merge,
  mq: mq
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/util.js
// module id = 17
// module chunks = 168707334958949